import { Input } from "@frui.ts/bootstrap";
import { observer } from "mobx-react-lite";
import React from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Icon, { IconType } from "@edaz/edazkit/Icon";
import FormGroup from "controls/formGroup";
import FilterView from "../../common/filter";
import type EmailBlacklistsViewModel from "viewModels/administration/emailBlacklist/emailBlacklistsViewModel";

export interface EmailBlacklistFiltersProps {
  vm: EmailBlacklistsViewModel;
}

const EmailBlacklistFilters = observer((props: EmailBlacklistFiltersProps) => {
  const { vm } = props;

  return (
    <FilterView vm={vm}>
      <div className="row">
        <FormGroup as={Col} md={6} lg={4} target={vm.filter} property="emailAddressSearchPattern">
          <Form.Label>{vm.translateFilterAttribute("emailAddressSearchPattern")}</Form.Label>
          <Input placeholder={vm.translate("placeholders.emailAddressSearchPattern")} />
        </FormGroup>
        <FormGroup as={Col} md={6} lg={4} target={vm.filter} property="description">
          <Form.Label>{vm.translateFilterAttribute("description")}</Form.Label>
          <Input placeholder={vm.translate("placeholders.description")} />
        </FormGroup>
        <FormGroup as={Col} md={6} lg={4} target={vm.filter} property="emailAddress">
          <Form.Label>
            {vm.translateFilterAttribute("emailAddress")}{" "}
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="email-address-tooltip">{vm.translate("emailAddressTooltip")}</Tooltip>}>
              <span>
                <Icon icon={IconType.MiniInfo} width={16} height={16} className="text-info cursor-pointer" />
              </span>
            </OverlayTrigger>
          </Form.Label>
          <Input placeholder={vm.translate("placeholders.emailAddress")} />
        </FormGroup>
      </div>
    </FilterView>
  );
});

export default EmailBlacklistFilters;
